<script>
  import { _ } from "svelte-i18n";
  
  export let part = {};

  $: enduranceDuration = part.metrics && (part.metrics.calm || part.metrics.moderate || part.metrics.high)
    ? (parseInt(part.metrics.calm) || 0) +
      (parseInt(part.metrics.moderate) || 0) +
      (parseInt(part.metrics.high) || 0)
    : 0;
</script>

{#if part.duration || (part.type === "endurance" && enduranceDuration > 0)}
  <div style="grid-column:4; justify-self:end">
    {#if part.type === "endurance"}
      {#if enduranceDuration > 0}
                      {enduranceDuration} {$_("sessions.unit")}
      {:else}
                  {part.duration || 0} {$_("sessions.unit")}
      {/if}
    {:else}
              {part.duration} {$_("sessions.unit")}
    {/if}
  </div>
{/if}
